/*
 * @Description: 项目结算管理
 * @Date: 2025-06-03 11:19:16
 */
import { route } from './src/router';

const name = 'settlement-mgmt';
export { name, route };
